export const adaptiveBatchIntervalPolicy = {
  baseIntervalMs: 200,
  fullRateClientCount: 40,
  maxIntervalMs: 5000,
} as const;

/**
 * Each client's message fans out to every other client, so total deliveries
 * grow with the number of sender-recipient pairs.
 */
export function getAdaptiveBatchIntervalMs(clientCount: number): number {
  const { baseIntervalMs, fullRateClientCount, maxIntervalMs } =
    adaptiveBatchIntervalPolicy;
  const senderRecipientPairs = clientCount * (clientCount - 1);
  const fullRateSenderRecipientPairs = fullRateClientCount * (fullRateClientCount - 1);
  return Math.min(
    maxIntervalMs,
    baseIntervalMs * Math.max(1, senderRecipientPairs / fullRateSenderRecipientPairs),
  );
}
